import { Clock } from 'lucide-react';

import { Badge } from '@/components/ui/badge';

/** "12m", "3h", "2d": how long the lead has waited, short enough for a row. */
export function formatWaitedFor(since: string, now: Date = new Date()) {
  const minutes = Math.max(
    1,
    Math.floor((now.getTime() - new Date(since).getTime()) / 60_000)
  );
  if (minutes < 60) return `${minutes}m`;
  if (minutes < 48 * 60) return `${Math.floor(minutes / 60)}h`;
  return `${Math.floor(minutes / (24 * 60))}d`;
}

/**
 * A lead-form lead Claire did not message, that nobody on the team has
 * answered yet. Without it the lead reads as just another "new" lead.
 */
export function WaitingForTeamBadge({
  since,
  now,
}: {
  since: string;
  now?: Date;
}) {
  const waited = formatWaitedFor(since, now);
  return (
    <Badge
      className="gap-1 border-transparent bg-orange-50 font-medium text-orange-700 dark:bg-orange-950 dark:text-orange-300"
      title={`Claire did not message this lead. They have been waiting ${waited} for a reply from your team.`}
    >
      <Clock aria-hidden className="size-3" />
      {/* Short on a phone, where the lead's name needs the room. */}
      Waiting<span className="hidden md:inline"> for you</span> · {waited}
    </Badge>
  );
}
